import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MonthlyInvoiceComponent } from './monthly-invoice.component';


const routes: Routes = [
  {
    path: '',
    component: MonthlyInvoiceComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MonthlyInvoiceRoutingModule { }
